<div class="block relative">
  <h1>Lager</h1>
  <oms-inventory-notice></oms-inventory-notice>
  @if(authorizedForInventory) {
    <woo-tabs default="lager">
      <woo-tab label="Lager" name="lager">
        <inventory-view></inventory-view>
      </woo-tab>
      <woo-tab label="Månadsrapporter" name="inventory_reports">
        <inventory-reports></inventory-reports>
      </woo-tab>
    </woo-tabs>
  }
</div>
